// Anonymous, per-tab session ID shared by all client telemetry (web vitals and
// product events), so the two can be joined in BigQuery on a common id.
//
// PHI NOTE: this ID is generated with cryptographic randomness and has NO
// correlation to any healthcare DB, encounter, or Auth0 identity. Never replace
// it with an encounter-scoped or user-derived ID (see
// docs/2026-04-22-encounter-session-id-design.md) — that would defeat the whole
// point of keeping telemetry PHI-free.

let anonymousSessionId: string | null = null;

export const getAnonymousSessionId = (): string => {
  if (!anonymousSessionId) {
    const webCrypto = typeof crypto !== 'undefined' ? crypto : undefined;

    if (webCrypto?.randomUUID) {
      anonymousSessionId = webCrypto.randomUUID();
    } else if (webCrypto?.getRandomValues) {
      // Cryptographically strong fallback when randomUUID isn't available —
      // 16 random bytes as hex. Keeps the "no guessable join key" guarantee.
      const bytes = webCrypto.getRandomValues(new Uint8Array(16));
      anonymousSessionId = Array.from(bytes, (b) =>
        b.toString(16).padStart(2, '0')
      ).join('');
    } else {
      // Last resort only (no Web Crypto at all — should never happen in a browser).
      anonymousSessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
  }

  return anonymousSessionId;
};
